import React, { useContext, useEffect, useState } from 'react';
import FeatureGatesContext from '../contexts/FeatureGatesContext';
import DatasetDefinitionsContext from '../contexts/DatasetDefinitionsContext';
import AccountContext from '../contexts/AccountContext';
import BrandedBootLoader from '../components/BrandedBootLoader';
import BaseViewsContext from '../contexts/BaseViewsContext';
import LegacySavedFiltersContext from '../contexts/LegacySavedFiltersContext';
import SplashScreenProviders from '../contextProviders/SplashScreenProviders';

const useIsLoadingCriticalData = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { isLoading: isLoadingAccount } = useContext(AccountContext);
  const { isLoading: isLoadingGates } = useContext(FeatureGatesContext);
  const { isLoading: isLoadingSavedFilters } = useContext(
    LegacySavedFiltersContext,
  );

  const { isLoading: isLoadingDatasets } = useContext(
    DatasetDefinitionsContext,
  );
  const { isLoading: isLoadingBaseViews } = useContext(BaseViewsContext);

  useEffect(() => {
    setIsLoading(
      isLoadingGates ||
        isLoadingDatasets ||
        isLoadingAccount ||
        isLoadingBaseViews ||
        isLoadingSavedFilters,
    );
  }, [
    isLoadingAccount,
    isLoadingBaseViews,
    isLoadingDatasets,
    isLoadingGates,
    isLoadingSavedFilters,
  ]);

  return isLoading;
};

export const SplashScreenLoadingGate = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const isLoading = useIsLoadingCriticalData();
  if (isLoading) {
    return <BrandedBootLoader testId="splash-screen" />;
  }
  return <>{children}</>;
};

/**
 * Here we load up a bunch of configuration data and show a spinner until it
 * is ready.
 */
const SplashScreen = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  return (
    <SplashScreenProviders>
      <SplashScreenLoadingGate>{children}</SplashScreenLoadingGate>
    </SplashScreenProviders>
  );
};

export default SplashScreen;
